import { BOOKING_SOURCES } from "utils/constants";

/**
 * Gets booking source object by source ID
 * @param {string} sourceId - The source identifier
 * @returns {object} Booking source object
 */
export const getSourceById = (sourceId) => {
  return (
    Object.values(BOOKING_SOURCES).find((source) => source.id === sourceId) ||
    BOOKING_SOURCES.DEFAULT
  );
};

/**
 * Redux selector for current booking source object
 * @param {object} state - Redux state
 * @returns {object} Current booking source object
 */
export const selectCurrentSource = (state) => {
  const sourceId = state.booking.bookingSource;
  return getSourceById(sourceId);
};

/**
 * Redux selector for current booking source ID
 * @param {object} state - Redux state
 * @returns {string} Current booking source ID
 */
export const selectCurrentSourceId = (state) => {
  return state.booking.bookingSource || BOOKING_SOURCES.DEFAULT.id;
};

export const preserveSourceInQueryParams = (searchParams) => {
  const preservedParams = {};
  if (searchParams.source) {
    preservedParams.source = searchParams.source;
  }
  return preservedParams;
};

export default {
  getSourceById,
  selectCurrentSource,
  selectCurrentSourceId,
  preserveSourceInQueryParams,
};
